import { Empty, EmptyDescription, EmptyHeader, EmptyTitle } from '@clouway/ui'

type PagePlaceholderProps = {
  title: string
}

function PagePlaceholder({ title }: PagePlaceholderProps) {
  return (
    <Empty>
      <EmptyHeader>
        <EmptyTitle>{title}</EmptyTitle>
        <EmptyDescription>This screen is not implemented yet.</EmptyDescription>
      </EmptyHeader>
    </Empty>
  )
}

export default PagePlaceholder
